import { TypedDocumentNode, gql } from '@apollo/client';

import useMutation from '@sorare/core/src/hooks/graphql/useMutation';

import {
  footballRivalsRemindGameMutation,
  footballRivalsRemindGameMutationVariables,
} from './__generated__/useFootballRivalsRemindGame.graphql';

const FOOTBALL_RIVALS_REMIND_GAME_MUTATION = gql`
  mutation footballRivalsRemindGameMutation(
    $input: footballRivalsRemindGameInput!
  ) {
    footballRivalsRemindGame(input: $input) {
      game {
        slug
        shouldNotify
      }
      errors {
        code
        message
      }
    }
  }
` as TypedDocumentNode<
  footballRivalsRemindGameMutation,
  footballRivalsRemindGameMutationVariables
>;

export const useFootballRivalsRemindGame = () => {
  const [mutate, { loading }] = useMutation(
    FOOTBALL_RIVALS_REMIND_GAME_MUTATION
  );

  const mutateWithOptimisticResponse = async ({
    variables,
    slug,
  }: {
    variables: footballRivalsRemindGameMutationVariables;
    slug: string;
  }) => {
    const result = await mutate({
      variables,
      optimisticResponse: {
        footballRivalsRemindGame: {
          __typename: 'footballRivalsRemindGamePayload',
          game: {
            __typename: 'FootballRivalsGame',
            slug,
            shouldNotify: variables.input.shouldNotify,
          },
          errors: [],
        },
      },
    });

    return result;
  };

  return {
    mutate: mutateWithOptimisticResponse,
    loading,
  };
};
